import { BankAccount, CompanyProfile, ObligationType, SalaryPart } from '../types';

export const formatMoney = (n: number) => new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }).format(n);
export const todayISO = () => new Date().toISOString().split('T')[0];
export const formatDay = (d?: string | null) => d ? `${d.slice(8, 10)}.${d.slice(5, 7)}.${d.slice(0, 4)}` : '';
export const daysBetween = (from: string, to: string) =>
    Math.round((new Date(to).getTime() - new Date(from).getTime()) / (1000 * 3600 * 24));

const MONTHS = ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'];
// «YYYY-MM» или «YYYY-MM-DD» -> «октябрь 2026»
export const periodLabel = (p?: string | null) => p ? `${MONTHS[Number(p.slice(5, 7)) - 1]} ${p.slice(0, 4)}` : '';

// У ИП в профиле хранится только ФИО, «ИП» добавляем при показе
export const orgDisplayName = (org?: CompanyProfile | null) =>
    !org ? '' : org.type === 'ENTREPRENEUR' ? `ИП ${org.name}` : org.name;

export const accountLabel = (a: BankAccount) => `${a.bankName} •${a.accountNumber.slice(-4)}`;

export const OBLIGATION_TITLES: Record<ObligationType, string> = {
    NDFL: 'НДФЛ', CONTRIBUTIONS: 'Страховые взносы', INJURIES: 'Травматизм (СФР)', USN: 'УСН', VAT: 'НДС',
    IP_FIXED: 'Взносы ИП (фиксированные)', IP_1PCT: 'Взносы ИП 1%',
};

// Аванс или расчёт — по ближайшему к дате дню выплаты из настроек организации
export const defaultSalaryPart = (date: string, org?: CompanyProfile): SalaryPart => {
    const day = Number(date.slice(8, 10));
    const dist = (a: number, b: number) => { const x = Math.abs(a - b); return Math.min(x, 31 - x); };
    return dist(day, org?.advanceDay ?? 25) <= dist(day, org?.settlementDay ?? 10) ? 'ADVANCE' : 'FINAL';
};

// Аванс — за текущий месяц; расчёт в первой половине месяца — за прошлый, в конце месяца — за текущий
export const defaultSalaryPeriod = (date: string, part: SalaryPart): string => {
    let y = Number(date.slice(0, 4)), m = Number(date.slice(5, 7));
    if (part === 'FINAL' && Number(date.slice(8, 10)) < 15) { m -= 1; if (m === 0) { m = 12; y -= 1; } }
    return `${y}-${String(m).padStart(2, '0')}`;
};
